module.exports = __webpack_public_path__ + "static/media/rin-result.626bd282.png";